import script from "./PaymentMethodsDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentMethodsDrawer.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__